import React from "react";

interface CustomButtonProps {
  children: React.ReactNode;
  variant?: "primary" | "outline" | "outlinewithcolor";
  className?: string;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  colorClass?: string;
}

export const CustomButton: React.FC<CustomButtonProps> = ({
  children,
  variant = "primary",
  className = "",
  onClick,
  type = "button",
  disabled = false,
  colorClass = "",
}) => {
  const base =
    "w-full rounded-full  font-poppins text-lg transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 ";
  const variants = {
    primary:
      "bg-primary text-white border p-3 hover:bg-primary-dark active:bg-primary-dark",
    outline:
      "bg-white text-primary border p-3 hover:bg-primary/10 active:bg-primary/20",
    outlinewithcolor:
      "bg-white text-primary border border-primary p-3 hover:bg-primary/10 active:bg-primary/20",
  };
  return (
    <button
      type={type}
      className={`${base} ${variants[variant]} ${colorClass} ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};
